import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=4d09f9e6&scoped=true&"
import script from "./AccountMenu.vue?vue&type=script&lang=js&"
export * from "./AccountMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=4d09f9e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09f9e6",
  null
  
)

export default component.exports